import { Outlet } from 'react-router-dom';

const EURPage = () => {

  return (
    <>
      <Outlet />
    </>
  );
}

export default EURPage;